import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DictionaryService } from 'src/app/librarys/serves/public/dictionary.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from '../../kms.service';
declare var $;
@Component({
  selector: 'app-quick-triple-search',
  templateUrl: './quick-triple-search.component.html',
  styleUrls: ['./quick-triple-search.component.css']
})
export class QuickTripleSearchComponent implements OnInit {
  // 向父组件传值
  @Output() componentState = new EventEmitter();
  // 词条名称关键字
  keyword = '';
  // 词条列表数据
  datas1:any = [];
  // 分页参数
  pageBase: any = {
    current: 1,
    size: 20
  };
  // 词条详情
  datas:any = [];
  state:string = 'list';

  constructor(
    private kmsService: KmsService,
    private jwt: SwJwtService,
    private dicService: DictionaryService,
    private message: SwMassageBoxService,
  ) { }

  ngOnInit() {
    this.getData();
  }

   // 查询
   handleSearchClick(){
    this.pageBase = {
      current: 1,
      size: 20
    };
    this.getData();
  }

  // 重置
  handleReloadClick(){
    this.keyword = '';
    this.handleSearchClick();
  }

  // 分页查询
  getData(){
    let keyword = $.trim(this.keyword);
    let params = {
      current: this.pageBase.current,
      size: this.pageBase.size,
      name: keyword,
    }
    this.kmsService.queryRdfName(params).subscribe(
      data => {
        if (data.code == '200') {
          this.datas1 = data.data.records ? data.data.records : [];
          this.pageBase = data.data;
        } else {
          console.log(data.msg);
        }
      }
    );
  }

  // 查询详情
  getDetail(item){
    this.state = 'detail';
    let params = {
      "name": item.name,
      "uniqueId": item.uniqueId
    }
    this.kmsService.queryRdfList(params).subscribe(
      data => {
        if (data.code == '200') {
          this.datas = data.data ? data.data : [];
        } else {
          console.log(data.msg);
        }
      }
    );
  }

  // 分页点击方法
  clickPageQuery(event) {
    this.pageBase['pageNum'] = event.current;
    this.pageBase['pageSize'] = event.size;
    this.getData();
  }

  // 返回查询列表页面
  back(){
    this.state = 'list';
  }

  // 头部按钮点击事件
  clickToolbar(state){
    switch(state){
        case 'close': {
            this.componentState.emit(state);
            break;
        }
    }
  }

  // 选中某个属性
  selectKey(item){
    let data = {
      "materialId":'',
      "sourceText":item.value,
      "sourceMaterial":'',
      "pageNum":null,
      "relPageNum":null,
      "datasource":item.source
    }
    this.jwt.setToKen('materialTextSelect',JSON.stringify(data));
    this.message.info('选中'+' '+item.name+' '+item.key);
  }
}
